export var calculateAverageRating = function (reviews) {
    if ((reviews === null || reviews === void 0 ? void 0 : reviews.length) === 0)
        return 0;
    var sum = reviews.reduce(function (acc, review) { return acc + parseInt(review.rating); }, 0);
    return Number((sum / (reviews === null || reviews === void 0 ? void 0 : reviews.length)).toFixed(1));
};
